
const ProductTypeInList = ({ city,  inputValue, product, setProductType, productNameFiled }) => {
    
    inputValue=inputValue.trim().toLowerCase()
    let productTypeParts = []
    let currentIndex = 0
    
    while(currentIndex <= product[productNameFiled].length && inputValue.length > 0) {
        let index = product[productNameFiled].trim().toLowerCase().indexOf(inputValue, currentIndex)
        
        if(index === -1) {
            productTypeParts.push({
                text: product[productNameFiled].slice(currentIndex),
                highlighted: false
            })
            
            break
        }
        
        productTypeParts.push({
            text: product[productNameFiled].slice(currentIndex, index),
            highlighted: false
        })
        
        productTypeParts.push({
            text: product[productNameFiled].slice(index, index + inputValue.length),
            highlighted: true
        })
        currentIndex = index + inputValue.length
    }
    
    const handleProductTypeClick = (e) => {
        setProductType({
            id: product.id,
            "en-name": product["en-name"],
            "ru-name": product["ru-name"],
            "tr-name": product["tr-name"],
            "gtip-code": product["gtip-code"],
            "item-code": product["item-code"],
            weight: product.weight,
            warning: product.warning,
        });
    };

    if(productTypeParts.length === 0) {
        return (
            <div 
                className='text-2xs px-4 py-1 text-left cursor-pointer' 
                style={{borderBottom: "1px solid rgba(163, 163, 163, 0.33)"}} 
                onClick={handleProductTypeClick}
            > 
                {product[productNameFiled]}
            </div>
        )
        
    }

    return (
        <div className='text-2xs px-4 py-1 text-left cursor-pointer' style={{borderBottom: "1px solid rgba(163, 163, 163, 0.33)"}} onClick={handleProductTypeClick}>
            {productTypeParts.map((part,index) => {
                if(part.highlighted) {
                    return <span key={index} className="text-green-600">{part.text}</span>
                }
                return <span key={index}>{part.text}</span>
            })}
        </div>
    );
};

export default ProductTypeInList;
